/** Verfahrensmotor Slice 1 — Approval-Card + PB-Index (Portal). */

export const FRIST_APPROVAL_KIND = 'frist_vorschlag' as const;

export type FristApprovalKind = typeof FRIST_APPROVAL_KIND;

/** Entscheidung auf der Approval-Card (Slice 1). */
export type FristApprovalDecision = 'approved' | 'rejected' | 'self_answered';

/** PB-Index: Status einer gespeicherten Frist. */
export type PortalFristStatus = 'aktiv' | 'ersetzt' | 'widerrufen';

/** UI-Status der Card (inkl. ausstehend / widerrufen nach Ja). */
export type FristApprovalCardStatus =
  | 'pending'
  | 'approved'
  | 'rejected'
  | 'self_answered'
  | 'revoked'
  | 'error';

/** Strukturierter Bot-Message-Typ `approval_frist` (n8n → Portal). */
export interface ApprovalFristPayload {
  card_id: string;
  approval_kind: FristApprovalKind;
  frist_typ_vorschlag: string;
  start_datum: string;
  ende_vorschau: string;
  kalender_trace: string;
  regel_id?: string;
  motor_audit_id?: string;
  akte_nc_path?: string;
  quell_dokument_nc_path?: string;
  quell_dokument_display_name?: string;
  /** Optionaler PB-Record der Quelldatei (Hub-Index). */
  quell_dokument_pb_id?: string;
  begruendung_kurz?: string;
}

export interface FristApprovalCardState {
  payload: ApprovalFristPayload;
  status: FristApprovalCardStatus;
  decision?: FristApprovalDecision;
  resolvedAt?: string;
  pbRecordId?: string;
  errorMessage?: string;
}

/** PocketBase `portal_fristen` — Index nach Bestätigung (Slice 1). */
export interface PortalFristRecord {
  id: string;
  customer_id: string;
  /** S2: autoritativer PB-Akt-Scope für neue/aktualisierte Fristen. */
  akte_id?: string;
  kanzlei_id?: string;
  akte_nc_path: string;
  quell_dokument_nc_path: string;
  frist_typ: string;
  start_datum: string;
  ende_datum: string;
  regel_id: string;
  motor_audit_id: string;
  kalender_trace: string;
  bestaetigt_von: string;
  bestaetigt_am: string;
  status: PortalFristStatus;
  card_id?: string;
  created?: string;
  updated?: string;
}

export interface PortalFristenApiResult {
  ok: boolean;
  pbRecordId?: string;
  motor_audit_id?: string;
  ende_datum?: string;
  kalender_trace?: string;
  regel_id?: string;
  error?: string;
}

export interface PortalFristApprovalWebhookBody {
  action:
    | 'confirm'
    | 'reject'
    | 'self_answer'
    | 'revoke'
    | 'preview'
    | 'create'
    | 'update';
  customerId: string;
  card_id: string;
  approval_kind: FristApprovalKind;
  /** S2: für create/update Pflicht; n8n prüft Akte + Schreibrecht serverseitig. */
  akte_id?: string;
  frist_typ_vorschlag?: string;
  start_datum?: string;
  regel_id?: string;
  /** Eigen benannte Frist: Erinnerungstag (YYYY-MM-DD). Leer = am Fristtag. */
  erinnerung_datum?: string;
  motor_audit_id?: string;
  akte_nc_path?: string;
  quell_dokument_nc_path?: string;
  quell_dokument_pb_id?: string;
  pb_record_id?: string;
  bestaetigt_von?: string;
  /** n8n PB-Tenant-Auflösung (field|demo). */
  tenant?: string;
  customerStatus?: string;
}
